import PropTypes from 'prop-types';
import React from 'react';

const StopsRow = ({ journeyId, stops = [], row: StopRow }) => {
  return stops.map((stop, key) => (
    <StopRow
      key={stop.stopId || stop.id || `${journeyId}-${key}`}
      journeyId={journeyId}
      stopId={key}
      index={key}
      numberOfStops={stops.length}
    />
  ));
};

StopsRow.propTypes = {
  stops: PropTypes.array,
};

export default StopsRow;
